export default "__VITE_ASSET__tgO_vXVp__"